import { Fragment } from "react";
import profileIMG from "../../../Assets/Images/Image/dashboard/profile.png";
import Loading from "../../Shear/Loading/Loading";
// import ProfileUpdateModal from "../../Shear/Modal/ProfileUpdateModal";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import auth from "../../../FirebaseInit/FirebaseInit";
import { useAuthState } from "react-firebase-hooks/auth";
import { useQuery } from "react-query";

const Profile = () => {
  const [user, PLoading] = useAuthState(auth);
  let navigate = useNavigate();

  const { data, isLoading } = useQuery(["single-user", user], () =>
    fetch(`https://itghar-back.onrender.com/single-user?email=${user?.email}`, {
      method: "GET",
      headers: {
        authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    }).then((res) => {
      if (res.status === 401 || res.status === 403) {
        navigate("/");
        signOut(auth);
      }

      return res.json();
    })
  );

  if (isLoading || PLoading) {
    return <Loading />;
  }

  return (
    <Fragment>
      {PLoading ? (
        <Loading />
      ) : (
        <div className=" px-3 pb-3 max-xl:ml-10 max-xl:p-0">
          <div>
            <h3 className="mb-[28px] mt-5 leading-[38px]  max-sm:leading-[1.1428] color-[#000001] font-fira font-bold text-[20px] max-sm:text-[28px]">
              My Profile
            </h3>
            <div className="flex justify-between items-center border-b-[2px] border-[#f3f3f3] pb-3">
              <div className="relative w-[100px] h-[100px]">
                <img
                  className="w-[100px] h-[100px] rounded-full "
                  src={
                    data?.image ? data?.image || data.data.image : profileIMG
                  }
                  alt="IT Ghar"
                />
                <span className="w-[10px] h-[10px] inline-block absolute top-[10px] right-[10px]  rounded-full bg-primary"></span>
              </div>
              <button className="bg-linear-gradient py-2 font-semibold px-5 rounded-md text-[#fff] ">
                <i className="fa-solid fa-pen-to-square mr-1"></i>
                Edit Profile
              </button>
            </div>
            <div className="mt-5">
              <div>
                <h4 className="text-lg font-fira font-semibold">Full Name:</h4>
                <p className=" text-base text-[#1f1f1f]">{data?.name}</p>
              </div>
              <div className=" mt-3">
                <h4 className="text-lg font-fira font-semibold"> Email:</h4>
                <p className=" text-base text-[#1f1f1f]">{data?.email}</p>
              </div>
              <div className=" mt-3">
                <h4 className="text-lg font-fira font-semibold">Phone:</h4>
                <p className=" text-base text-[#1f1f1f]">
                  {data?.number ? data?.number : "+8801....."}
                </p>
              </div>
              <div className="mt-3">
                <h4 className="text-lg font-fira font-semibold">Address:</h4>
                <p className="text-base text-[#1f1f1f]">
                  {data?.address ? data?.address : "Bangladesh"}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* {open && (
        <ProfileUpdateModal
          setOpen={setOpen}
          setUpdate={setUpdate}
          profile={profile}
        />
      )} */}
    </Fragment>
  );
};

export default Profile;
